/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactNode } from "react";

const ModalDialog = function (props: {
  size: "sm" | "md" | "lg" | "xl" | "tracking";
  children: ReactNode;
  onHide?: () => void;
}) {
  const { size, children, onHide } = props;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (onHide && e.target === e.currentTarget) {
      onHide();
    }
  };
  return (
    <div className="d-flex justify-content-center align-items-center w-100 h-100" onClick={handleBackdropClick}>
      <div className={`cb-modal cb-modal-${size}`}>{children}</div>
    </div>
  );
};

export default ModalDialog;

ModalDialog.defaultProps = {
  onHide: undefined,
};
